import routes from './routes';
import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from './enums';
import { useMenuPermissionsStore } from '@centric-os/stores/auth/use-menu-permissions-store';
import { SitesRouteNames } from '@centric-os/sites';

const App = () => import('./App.vue');

export * from './enums';

export const route: RouteRecordRaw = {
  path: buildRootURL(LocalMenuGroupRoutePathNames.LOCAL_MENUS),
  name: LocalMenuGroupRouteNames.LOCAL_MENUS_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
  children: routes,
  beforeEnter: () => {
    const menuPermissionsStore = useMenuPermissionsStore();

    if (menuPermissionsStore.canAccessLocalMenuGroupsSection) {
      return true;
    }

    // Change to HOME when we have dashboard
    return { name: SitesRouteNames.SITES_LIST };
  },
};
